import { PublicLayout } from "@components/layouts/PublicLayout";
import { SignupView } from "@/containers/login/SignupView";

const SignupPage = () => {
    return (
        <PublicLayout>
            <SignupView />
        </PublicLayout>
    ) ;
}

export default SignupPage ;